import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-bpams.component.scss?ngResource";
import { Component } from "@angular/core";
import { ViewApplicationDetailsBpamsConstants } from "./view-application-details-bpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
export let ViewApplicationDetailsBpamsComponent = class ViewApplicationDetailsBpamsComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    routerParamsService;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = ViewApplicationDetailsBpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    descriptionLabel = ViewApplicationDetailsBpamsConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = ViewApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_LABEL;
    sectorLabel = ViewApplicationDetailsBpamsConstants.SECTOR_LABEL;
    isRDPLabel = ViewApplicationDetailsBpamsConstants.IS_RDP_LABEL;
    buildingUseLabel = ViewApplicationDetailsBpamsConstants.BUILDING_USE_LABEL;
    isMinorBuildingWorkFormControlName = ViewApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    sectorFormControlName = ViewApplicationDetailsBpamsConstants.SECTOR_FORM_CONTROL_NAME;
    isRDPFormControlName = ViewApplicationDetailsBpamsConstants.IS_RDP_FORM_CONTROL_NAME;
    buildingUseFormControlName = ViewApplicationDetailsBpamsConstants.BUILDING_USE_FORM_CONTROL_NAME;
    application;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.subscribeToSelectedApplication();
        this.listenForRouteParamChange();
    }
    handleRouteChange() {
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(application.isMinorBuildingWork);
        this.detailsForm.get(this.isMinorBuildingWorkFormControlName).disable();
        this.detailsForm.get(this.sectorFormControlName).setValue(application.sector);
        this.detailsForm.get(this.sectorFormControlName).disable();
        this.detailsForm.get(this.isRDPFormControlName).setValue(application.isRdp);
        this.detailsForm.get(this.isRDPFormControlName).disable();
        this.detailsForm.get(this.buildingUseFormControlName).setValue(application.buildingUse);
        this.detailsForm.get(this.buildingUseFormControlName).disable();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsBpamsComponent = __decorate([
    Component({
        selector: "app-view-application-details-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsBpamsComponent);
